import React from "react";
import { useTranslation } from "react-i18next";

const ClosedNotice = ({ className = "" }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`text-center ${className}`}
      role="status"
      style={{
        background: "#fdecea",
        color: "#b3261e",
        borderRadius: 8,
        padding: "10px 14px",
        margin: "12px 15px",
        fontWeight: 600,
        fontSize: 14,
      }}
    >
      {t("This service is currently closed")}
    </div>
  );
};

export default ClosedNotice;
